module.exports = __webpack_public_path__ + "img/Slice 268@2x(2).91351505.png";